module.exports = __webpack_public_path__ + "img/select-or-create-audience.67867857.svg";